import { scApi } from './scrapecreators/shared';
import { WEB_PLATFORM_LABEL } from './platformLabels';

/** Hand-authored copy and examples for web discovery SKUs. */
export const WEB = scApi({
  id: 'web',
  name: WEB_PLATFORM_LABEL,
  category: 'Search',
  color: 'var(--c-blue)',
  blurb:
    'Turn any website into clean data: scrape a page to Markdown, map a site into its URLs, crawl whole sites into LLM-ready text, or capture real-browser screenshots. One key, one wallet, billed per request in real dollars.',
  endpoints: {
    scrape: {
      action: 'Scrape page',
      description:
        'Scrape any web page and get its main content back as clean Markdown plus title and metadata.',
      input: { url: 'https://www.example.com/blog/launch' },
      sample: {
        url: 'https://www.example.com/blog/launch',
        title: 'Introducing Example 2.0',
        description: 'Everything new in the biggest Example release yet.',
        markdown:
          '# Introducing Example 2.0\n\nToday we are shipping the biggest release in our history…',
      },
    },
    map: {
      action: 'Map site',
      description:
        'Map an entire website into a clean list of its URLs, with titles and descriptions, in a single call.',
      input: { url: 'https://www.example.com', limit: 100 },
      sample: {
        results: [
          {
            url: 'https://www.example.com/pricing',
            title: 'Pricing - Example',
            description: 'Simple plans for teams of every size.',
          },
          {
            url: 'https://www.example.com/blog',
            title: 'Blog - Example',
            description: 'Product news and engineering deep dives.',
          },
        ],
      },
    },
    crawl: {
      action: 'Crawl website',
      description:
        'Crawl a website and get clean text content from up to 10 pages in one normalized response - ideal for feeding sites into LLMs and search indexes.',
      input: { url: 'https://www.example.com' },
      sample: {
        items: [
          {
            url: 'https://www.example.com',
            title: 'Example - Build something great',
            text: 'Example is the platform teams use to ship faster…',
          },
          {
            url: 'https://www.example.com/pricing',
            title: 'Pricing - Example',
            text: 'Simple plans for teams of every size…',
          },
        ],
      },
    },
    screenshot: {
      action: 'Screenshot page',
      description:
        'Capture a real-browser screenshot of any web page URL and get back a link to the rendered image.',
      input: { url: 'https://www.example.com', viewportWidth: 1280 },
      sample: {
        items: [
          {
            url: 'https://www.example.com',
            screenshotUrl: 'https://api.getanyapi.com/files/screenshots/3f9c1a.png',
          },
        ],
      },
    },
  },
});
